import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./Pages/About";
import CancellationPolicy from "./Pages/CancellationPolicy";
import RefundPolicy from "./Pages/RefundPolicy";
import ContactUs from "./Pages/ContactUs";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import GrievanceRedressal from "./Pages/GrievanceRedressal";
import TermsConditions from "./Pages/TermsConditions";
import Login from "./Login";
import PrivacyPolicyExpenseTracker from "./Pages/PrivacyPolicyExpenseTracker";
import TermsConditionsExpenseTracker from "./Pages/TermsConditionsExpenseTracker";
import PaymentStatus from "./Pages/PaymentStatus";
function App() {
  const [baseUrl, setBaseUrl] = useState("");
  useEffect(() => {
    document.title = "Dharmiq - Your Daily Spiritual Companion";
    const resolvedBaseUrl = process.env.REACT_APP_ENV === 'local' ? process.env.REACT_APP_BACKEND_URL_LOCAL : process.env.REACT_APP_BACKEND_URL;
    if (!resolvedBaseUrl) {
      console.error("REACT_APP_BACKEND_URL is not set — this build was produced without it, so API calls will hit the wrong URL.");
    }
    setBaseUrl(resolvedBaseUrl);
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home baseUrl={baseUrl} />} />
        <Route path="/about" element={<About />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy-expense-tracker" element={<PrivacyPolicyExpenseTracker />} />
        <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/terms-conditions-expense-tracker" element={<TermsConditionsExpenseTracker />} />
        <Route path="/login" element={<Login />} />
        <Route path="/payment-status" element={<PaymentStatus baseUrl={baseUrl} />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;